import { AUTH_VERDICT, AUTH_RESULT_PATTERN, AUTH_RESULTS } from "./consts";

export type AuthResult = {
  dkim: string[];
  spf: string[];
  dmarc: string[];
};

type Header = {
  name: string;
  value: string;
};

export const getEmailHeader = (
  headers: Header[] | undefined,
  headerName: string
) => headers?.find(({ name }) => name === headerName)?.value;

export const getReceivedHeaders = (headers: Header[] | undefined) =>
  headers?.filter(({ name }) => name === "Received").map(h => h.value);

export const getEmailAuthResults = (headers: Header[]) => {
  const authHeader = getEmailHeader(headers, "Authentication-Results");
  const matches = authHeader?.match(AUTH_RESULT_PATTERN);
  const result: AuthResult = { dkim: [], spf: [], dmarc: [] };

  if (!matches) return result;
  return matches?.reduce((acc, curr) => {
    const [key, value] = curr.split("=");
    if (!["spf", "dkim", "dmarc"].includes(key)) return acc;
    result[key as keyof AuthResult].push(value.toLowerCase());
    return result;
  }, result);
};

export const getEmailAuthVerdict = (auths: string[]) => {
  if (auths.length === 0) return AUTH_VERDICT.EMPTY;
  if (auths.some(element => AUTH_RESULTS.ERROR.includes(element))) {
    return AUTH_VERDICT.ERROR;
  }
  if (auths.some(element => AUTH_RESULTS.WARNING.includes(element))) {
    return AUTH_VERDICT.WARNING;
  }
  if (auths.some(element => AUTH_RESULTS.PASS.includes(element))) {
    return AUTH_VERDICT.PASS;
  }
  return AUTH_VERDICT.EMPTY;
};

export const getEmailDomain = (emailAddress: string) => {
  const emailParts = emailAddress.split("@");
  return !emailParts || emailParts.length === 1 ? undefined : emailParts.pop();
};

export const getEmailUsername = (emailAddress: string) => {
  const emailParts = emailAddress.split("@");
  return !emailParts ? undefined : emailParts.shift();
};
